import EDPanel from '../../../../BaseComponents/Panel/EDPanel';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../BaseComponents/Icon/Utils/IconDefinitions';
import { IRutinInfo } from '../../../../Types/RutinInfoType';
import { WidgetSize } from '../../Widgets';

export interface IWidgetContentProps {
  routineInfo?: IRutinInfo;
}

export interface IWidgetProps {
  /** Panel title */
  title: string;
  /** Icon type for EDIcon avatar */
  iconType?: IconType;
  /** Size hint used by parent container; component does not enforce */
  size?: WidgetSize;
  /** Either a full IRutinInfo or a key into IRutinInfos */
  routineInfo?: IRutinInfo;
  /** The inner component to render inside panel */
  component: React.ComponentType<IWidgetContentProps>;
  /** Test id for querying */
  testId?: string;
}

/**
 * Generic dashboard widget wrapper.
 * Renders an `EDPanel` with optional `EDIcon` avatar and supplied inner component.
 * Sizing is handled by parent container; this component stays flexible.
 */
const Widget: React.FC<React.PropsWithChildren<IWidgetProps>> = props => {
  const { title, iconType, component, testId, routineInfo } = props;

  const Component = component;

  return (
    <EDPanel
      title={title}
      avatar={
        iconType ? (
          <EDIcon color="action" iconType={iconType} size="special" />
        ) : undefined
      }
      headerPadding="normal"
      flex
      testId={testId || 'widgetPanel'}
      elevation={4}
      width={'100%'}
      height={'100%'}
      minWidth={'unset'}
      widgetStyle
    >
      <Component routineInfo={routineInfo} />
    </EDPanel>
  );
};

export default Widget;
